// extracted by mini-css-extract-plugin
module.exports = {"rotate":"loading_rotate__i0qi9","rotation":"loading_rotation__2_mAl","rotate2":"loading_rotate2__5A6jV"};